var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRatings())?_c('div',{staticClass:"dbs_pr-product-list__rating"},[_c('div',[_c('Rating',{attrs:{"rating":_vm.rating}}),_vm._v(" "),_c('div',{staticClass:"dbs_pr-product-list__ratings_count"},[_vm._v("("+_vm._s(_vm.count)+")")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e01ff9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RatingWithCounter.vue
// module id = null
// module chunks = 